import { z } from 'zod';

/**
 * API バリデーションエラーのレスポンス Zod スキーマ (HTTP 422)
 * FastAPI の標準的な 422 レスポンス形式に対応する。
 */
export const ValidationErrorResponseSchema = z.object({
  detail: z.array(
    z.object({
      loc: z.array(z.string()),
      msg: z.string(),
      type: z.string(),
    }),
  ),
});

/** API バリデーションエラーのレスポンス型 (HTTP 422) */
export type ValidationErrorResponse = z.infer<
  typeof ValidationErrorResponseSchema
>;

/**
 * API 汎用エラーレスポンスの Zod スキーマ (HTTP 4xx / 5xx)
 * detail が単一文字列のエラー形式に対応する。
 */
export const ErrorResponseSchema = z.object({
  detail: z.string(),
});

/** API 汎用エラーレスポンスの型 (HTTP 4xx / 5xx) */
export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;
